import * as React from 'react';
import { Navigation } from '../../navigation/navigation';
import { useRootStore } from '../../../../providers/root-store-provider';
import { routes } from '../../../../config/routes';
import { AccountBox } from '../../account-box/account-box';
import { Logo } from '../../../../components/app/logo/logo';
import { PortfolioSwitcher } from '../../../../components/app/portfolio/switcher/portfolio-switcher';

export const HeaderHorizontal: React.FC = () => {
    const rootStore = useRootStore();
    const { showHeaderBar } = rootStore.themeStore;

    return (
        <div
            className={`fixed left-0 z-[900] flex h-screen w-[23.2rem] flex-col border-r border-border bg-surface ${
                showHeaderBar ? 'top-bar' : 'top-0'
            }`}
        >
            <div className="flex items-center gap-xsmall border-b border-border pl-small md:gap-vsmall md:pl-medium vl:py-[2.7rem]">
                <Logo href={routes.app.index} inApp />
            </div>
            <Navigation />
            <div className="absolute left-[23.2rem] top-0 flex w-[calc(100vw-23.2rem)] items-center justify-between border-b border-border bg-body/90 p-small backdrop-blur-[0.5rem]">
                <PortfolioSwitcher />
                <AccountBox />
            </div>
        </div>
    );
};
